<div class="weather-station">
    <div class="weather-station-title">
        <ng-template #NoData>
            <p>No weather data</p>
        </ng-template>
    </div>
    <div class="grid-box-body grid-box-number">
        <highcharts-chart *ngIf="isWeatherData() && weatherStation.supportsWind"
            [Highcharts]="Highcharts"
            [options]="chartOptions"
            [callbackFunction]="chartCallback"
            [(update)]="updateFlag"
            [oneToOne]="oneToOneFlag"
            style="display: block; width: 100%;">
        </highcharts-chart>
        <div class="no-weather-data" *ngIf="weatherStation.supportsWind && !isWeatherData()">
            <p>No Wind Data</p>
        </div>
        <div *ngIf="isWeatherData() && (weatherStation.supportsRain || weatherStation.supportsWind)">
            <table>
              <tr *ngIf="weatherStation.supportsWind">
                <th>Temperature</th>
                <td [title]="weatherStation.deviceInTemperature.timeStamp">{{ weatherStation.deviceInTemperature.value ? (weatherStation.deviceInTemperature.value | number: '1.2-2') : '0' }} °C</td>
              </tr>   
              <tr *ngIf="weatherStation.supportsWind">
                <th>Wind Speed</th>
                <td [title]="weatherStation.deviceInWindSpeed.timeStamp">
                  {{ weatherStation.deviceInWindSpeed.value ? (weatherStation.deviceInWindSpeed.value | number: '1.2-2') : '0' }} m/s
                  @ {{ weatherStation.deviceInWindDirection.value || '0' }} °
                </td>
              </tr>
              <tr *ngIf="weatherStation.supportsWind">
                <th>Wind Gusts</th>
                <td [title]="weatherStation.deviceInGustSpeed.timeStamp">{{ weatherStation.deviceInGustSpeed.value ? (weatherStation.deviceInGustSpeed.value | number: '1.2-2') : '0' }} m/s</td>
              </tr>
              <tr *ngIf="weatherStation.supportsWind && weatherStation.weightedAverageWindSpeed">
                <th>Average Wind</th>
                <td [title]="weatherStation.weightedAverageWindSpeed.timeStamp">
                  {{ weatherStation.weightedAverageWindSpeed.value ? (weatherStation.weightedAverageWindSpeed.value | number: '1.2-2') : '0' }} m/s
                  @ {{ weatherStation.weightedAverageWindDirection.value || '0' }} °  
                </td>
              </tr>
            </table>    
    </div>
</div>